module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento17.1e25da70.svg";